module.exports = __webpack_public_path__ + "static/media/products.6efc5144.svg";